import { gql } from '@apollo/client';
import { ConfigurationFieldFragment } from '../fragments/ConfigurationFieldFragment';
/**
 * @const ConfigurationFieldsQuery
 * @since 1.0.0
 */
export const ConfigurationFieldsQuery = gql `
  query ConfigurationFieldsQuery($input: ConfigurationFieldsInput) {
    configurationFields(input: $input) {
      ...ConfigurationFieldFragment
    }
  }

  ${ConfigurationFieldFragment}
`;
